import stylesMediaText from '@components/media-text/MediaText.module.scss'
import Content from '@components/media-text/components/content/Content'
import Heading from '@components/media-text/components/heading/Heading'
import Visual from '@components/media-text/components/visual/Visual'
import { usePbProps } from '@content/helpers/src/context'
export default function PlaceholderPlaceholders({ onOpenModal }) {
    const { copywriting, campaign }: any = usePbProps()
    const {
        title,
        description,
        image,
        cta,
        cta_secondary,
        link,
        promotion_details,
        placeholders
    } = copywriting

    return (
        <>
            <div className={stylesMediaText['media-text__placeholder']}>
                <Visual
                    alt_text={image?.desktop?.alt}
                    desktop={image?.desktop?.src}
                    mobile={image?.mobile?.src}
                    retina={image?.retina?.src}></Visual>
            </div>
            <div className={stylesMediaText['media-text__content']}>
                <div>
                    <Heading title={title} />
                </div>
                <div>
                    <Content
                        onOpenModal={onOpenModal}
                        promotion_details={promotion_details}
                        link={link}
                        campaign={campaign}
                        text={description}
                        buttonPrimary={cta}
                        buttonSecondary={cta_secondary}
                        placeholders={placeholders}
                    />
                </div>
            </div>
        </>
    )
}
